<template>
  <div>
    <div class="head">
      <div class="icon">
        <span class="el-icon-s-grid"></span>
      </div>
      <h2>专题网站</h2>
      <h3>Featured &nbsp;&nbsp; websites</h3>
    </div>
    <el-row class="content" :gutter="20">
      <el-col
        class="item"
        v-for="item in FeaturedList"
        :key="item.featuredId"
        :md="8"
        :xs="24"
      >
        <a :href="item.linkUrl">
          <img :src="item.featuredImg" style="object-fit: cover;" />
        </a>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { apiService } from "@/api/ApiService.js";
export default {
  name: "Featured",
  mounted() {
    apiService.findFeaturedList().then(res => {
      this.FeaturedList = res.data;
      console.log(res.data);
    });
  },
  data() {
    return {
      FeaturedList: [],
      FeaturedList_old: [
        {
          articleModel: "300601",
          featuredImg: require("@/assets/imgs/二十大.png")
        },
        {
          articleModel: "300602",
          featuredImg: require("@/assets/imgs/依法治校.png")
        },
        {
          articleModel: "300603",
          featuredImg: require("@/assets/imgs/纪检监察.png")
        },
        {
          articleModel: "300604",
          featuredImg: require("@/assets/imgs/学习强国.png")
        },
        {
          articleModel: "300605",
          featuredImg: require("@/assets/imgs/文明校园.png")
        },
        {
          articleModel: "300606",
          featuredImg: require("@/assets/imgs/职业教育.png")
        }
      ]
    };
  }
};
</script>
<style scoped>
.head {
  position: relative;
  height: 0.175rem;
  border-bottom: 1px solid #6510ad;
}
.head > .icon {
  left: 0;
  bottom: 5px;
}
.head > .icon > span {
  font-size: 0.145rem;
}
.head > h2 {
  position: absolute;
  left: 0.2rem;
  bottom: 10px;
  font-size: 0.125rem;
}
.head > h3 {
  position: absolute;
  left: 0.75rem;
  bottom: 10px;
  color: grey;
  font-size: 0.08rem;
}
.content .item {
  margin: 0.05rem 0;
  cursor: pointer;
}
.content .item:hover {
  transform: scale(1.1, 1.1);
}
.content .item img {
  height: 0.75rem;
  width: 100%;
  box-shadow: 2px 3px 3px #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/Featured.vue